/* tslint:disable */
/* eslint-disable */
/**
 * Calvin Risk API
 * TBD
 *
 * The version of the OpenAPI document: 6.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { CustomQuestionnaireQuestionRuleTypeEnum } from './CustomQuestionnaireQuestionRuleTypeEnum';
import {
  CustomQuestionnaireQuestionRuleTypeEnumFromJSON,
  CustomQuestionnaireQuestionRuleTypeEnumFromJSONTyped,
  CustomQuestionnaireQuestionRuleTypeEnumToJSON,
} from './CustomQuestionnaireQuestionRuleTypeEnum';
import type { CustomQuestionnaireAnswerOption } from './CustomQuestionnaireAnswerOption';
import {
  CustomQuestionnaireAnswerOptionFromJSON,
  CustomQuestionnaireAnswerOptionFromJSONTyped,
  CustomQuestionnaireAnswerOptionToJSON,
} from './CustomQuestionnaireAnswerOption';
import type { CustomQuestionnaireQuestionRuleCondition } from './CustomQuestionnaireQuestionRuleCondition';
import {
  CustomQuestionnaireQuestionRuleConditionFromJSON,
  CustomQuestionnaireQuestionRuleConditionFromJSONTyped,
  CustomQuestionnaireQuestionRuleConditionToJSON,
} from './CustomQuestionnaireQuestionRuleCondition';
import type { CustomQuestionnaireQuestionRuleOperatorEnum } from './CustomQuestionnaireQuestionRuleOperatorEnum';
import {
  CustomQuestionnaireQuestionRuleOperatorEnumFromJSON,
  CustomQuestionnaireQuestionRuleOperatorEnumFromJSONTyped,
  CustomQuestionnaireQuestionRuleOperatorEnumToJSON,
} from './CustomQuestionnaireQuestionRuleOperatorEnum';

/**
 * Adds nested create feature
 * @export
 * @interface CustomQuestionnaireQuestionRule
 */
export interface CustomQuestionnaireQuestionRule {
  /**
   *
   * @type {number}
   * @memberof CustomQuestionnaireQuestionRule
   */
  order?: number;
  /**
   *
   * @type {CustomQuestionnaireQuestionRuleTypeEnum}
   * @memberof CustomQuestionnaireQuestionRule
   */
  type: CustomQuestionnaireQuestionRuleTypeEnum;
  /**
   *
   * @type {CustomQuestionnaireQuestionRuleOperatorEnum}
   * @memberof CustomQuestionnaireQuestionRule
   */
  operator: CustomQuestionnaireQuestionRuleOperatorEnum;
  /**
   *
   * @type {Array<CustomQuestionnaireQuestionRuleCondition>}
   * @memberof CustomQuestionnaireQuestionRule
   */
  conditions: Array<CustomQuestionnaireQuestionRuleCondition>;
  /**
   *
   * @type {Array<CustomQuestionnaireAnswerOption>}
   * @memberof CustomQuestionnaireQuestionRule
   */
  filteredOptions: Array<CustomQuestionnaireAnswerOption>;
  /**
   *
   * @type {CustomQuestionnaireAnswerOption}
   * @memberof CustomQuestionnaireQuestionRule
   */
  defaultValue?: CustomQuestionnaireAnswerOption;
}

/**
 * Check if a given object implements the CustomQuestionnaireQuestionRule interface.
 */
export function instanceOfCustomQuestionnaireQuestionRule(value: object): value is CustomQuestionnaireQuestionRule {
  if (!('type' in value) || value['type'] === undefined) return false;
  if (!('operator' in value) || value['operator'] === undefined) return false;
  if (!('conditions' in value) || value['conditions'] === undefined) return false;
  if (!('filteredOptions' in value) || value['filteredOptions'] === undefined) return false;
  return true;
}

export function CustomQuestionnaireQuestionRuleFromJSON(json: any): CustomQuestionnaireQuestionRule {
  return CustomQuestionnaireQuestionRuleFromJSONTyped(json, false);
}

export function CustomQuestionnaireQuestionRuleFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): CustomQuestionnaireQuestionRule {
  if (json == null) {
    return json;
  }
  return {
    order: json['order'] == null ? undefined : json['order'],
    type: CustomQuestionnaireQuestionRuleTypeEnumFromJSON(json['type']),
    operator: CustomQuestionnaireQuestionRuleOperatorEnumFromJSON(json['operator']),
    conditions: (json['conditions'] as Array<any>).map(CustomQuestionnaireQuestionRuleConditionFromJSON),
    filteredOptions: (json['filtered_options'] as Array<any>).map(CustomQuestionnaireAnswerOptionFromJSON),
    defaultValue:
      json['default_value'] == null ? undefined : CustomQuestionnaireAnswerOptionFromJSON(json['default_value']),
  };
}

export function CustomQuestionnaireQuestionRuleToJSON(value?: CustomQuestionnaireQuestionRule | null): any {
  if (value == null) {
    return value;
  }
  return {
    order: value['order'],
    type: CustomQuestionnaireQuestionRuleTypeEnumToJSON(value['type']),
    operator: CustomQuestionnaireQuestionRuleOperatorEnumToJSON(value['operator']),
    conditions: (value['conditions'] as Array<any>).map(CustomQuestionnaireQuestionRuleConditionToJSON),
    filtered_options: (value['filteredOptions'] as Array<any>).map(CustomQuestionnaireAnswerOptionToJSON),
    default_value: CustomQuestionnaireAnswerOptionToJSON(value['defaultValue']),
  };
}
